import { render, staticRenderFns } from "./Credential.vue?vue&type=template&id=05ffa102&scoped=true"
import script from "./Credential.vue?vue&type=script&lang=js"
export * from "./Credential.vue?vue&type=script&lang=js"
import style0 from "./Credential.vue?vue&type=style&index=0&id=05ffa102&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ffa102",
  null
  
)

export default component.exports